export default __webpack_public_path__ + "static/media/meet_logo.d64292b7.png";